<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<form id="FormDepartamento" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
				<div class="container-fluid">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Nombre">Nombre</label>
									<input type="text" v-model="objDepartamento.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
									<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
								</div>
							</div>
								
							<br>
						</div><!--fin col-12-->
					</div>
				</div>
			</form>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormDepartamento',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objDepartamento: {
				IdDepartamento: 0,
				Nombre: '',
				IdEmpresa: 0,
				IdSucursal: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objDepartamento.IdDepartamento == 0) {
				await this.$http.post(
					'departamentos',this.objDepartamento
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'departamentos/'+this.objDepartamento.IdDepartamento,
					this.objDepartamento
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "departamentos/"+this.objDepartamento.IdDepartamento
            ).then((res) => {
                this.objDepartamento = res.data.data;

				// en caso de que necesite fecha
				/*let formatedDate1 = this.objDepartamento.Fecha.replace(/-/g,'\/');
                this.objDepartamento.Fecha = new Date(formatedDate1);*/
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objDepartamento = {
				IdDepartamento: 0,
				Nombre: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objDepartamento.IdDepartamento = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
